import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/portaliLanding';
import { selectors, DEFAULT_STATE } from '../reducers/portaliLanding';
import api from '../apis/portaliLanding';

const sagas = helper.createSagas('portaliLanding', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];